import React, { ReactElement } from 'react'
import { Controller } from 'react-hook-form'
import Select from 'react-select'
import { ISearchSelect } from '../../interfaces/FormFields'
import ErrorMessage from '../Alerts/ErrorMessage'
import { searchSelectStyle } from './SearchSelectStyle'

const SearchSelect = ({
  error,
  options,
  value,
  placeHolder = 'Sélectionner',
  label,
  id,
  name,
  control,
  rules,
  onChange,
  className,
  required,
}: ISearchSelect): ReactElement => {
  return (
    <div className={className}>
      <label
        htmlFor={name}
        className={`inputLabel ${required ? 'inputLabelRequired' : ''}`}
      >
        {label}
      </label>
      <Controller
        id={id}
        name={name}
        placeholder={placeHolder}
        control={control}
        valueName={name}
        isClearable={false}
        trim={true}
        options={options}
        as={Select}
        rules={rules}
        onChange={([selected]) => onChange(selected)}
        defaultValue={value}
        value={value}
        styles={searchSelectStyle}
        className={`${error ? 'inputSelectError' : ''}`}
      />
      {error && (
        <div className="mb1">
          <ErrorMessage errorMessage={error.message} />
        </div>
      )}
    </div>
  )
}

export default SearchSelect
